class Timeline {
    constructor(elements) {
        this.elements = elements;
        if (!this.elements.length) return;
        this.init();
    }

    init() {
        this.setNavHeight();
        this.activateBtns();
    }

    setNavHeight() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--timeline-nav-height",
            document.querySelector(".timeline__nav").offsetHeight + "px",
        );
    }

    activateBtns() {
        function getClosestToCenter(entries) {
            let closest = null;
            let minDistance = Infinity;
            const viewportCenter = window.innerHeight / 2;

            entries.forEach((entry) => {
                if (!entry.isIntersecting) return; // Ignore non-visible elements

                const boundingBox = entry.boundingClientRect;
                const elementCenter = boundingBox.top + boundingBox.height / 2;
                const distance = Math.abs(viewportCenter - elementCenter);

                if (distance < minDistance) {
                    minDistance = distance;
                    closest = entry.target;
                }
            });

            return closest;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                const visibleEntries = entries.filter(
                    (entry) => entry.isIntersecting,
                );
                const closestElement = getClosestToCenter(visibleEntries);

                if (closestElement) {
                    document
                        .querySelectorAll("[data-timeline-button]")
                        .forEach((btn) => {
                            btn.classList.remove("active");
                        });

                    const currentBtn = document.querySelector(
                        `[data-timeline-button='${closestElement.dataset.timelineItem}']`,
                    );

                    if (currentBtn) {
                        currentBtn.classList.add("active");
                    }
                }
            },
            { threshold: 0.3 }, // Adjust threshold for better detection
        );

        this.elements.forEach((el) => observer.observe(el));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const timelineItems = document.querySelectorAll("[data-timeline-item]");
    new Timeline(Array.from(timelineItems));
});

export default Timeline;
